import { IRoutes } from "../../router/IRoutes";
import { RouteGenerators } from "./RouteGenerators";

export function convertRoutesToGenerator(routes: IRoutes): RouteGenerators {
    return Object.keys(routes).reduce<Partial<RouteGenerators>>((obj, key) => {
        const routeKey = key as keyof IRoutes;
        const route = routes[routeKey];
        obj[routeKey] = route
            ? (...args: any[]) => route.toString(...args)
            : undefined;
        return obj;
    }, {}) as RouteGenerators;
}
